/**
 * HttpClient wrapper that handles Http-only Cookies and Auth Refresh
 * as per auth_architecture_guide.md
 */

const API_BASE_URL = process.env.NEXT_PUBLIC_API_URL || '/api';

export const callApi = async (path: string, options: RequestInit = {}) => {
  const url = path.startsWith('http') ? path : `${API_BASE_URL}${path}`;

  const method = (options.method || 'GET').toUpperCase();
  const hasBody = options.body != null;
  const needsBody = ['POST', 'PUT', 'PATCH'].includes(method);

  const defaultOptions: RequestInit = {
    credentials: 'include',
    headers: {
      // Chỉ set Content-Type khi có body hoặc method cần body
      ...(hasBody || needsBody ? { 'Content-Type': 'application/json' } : {}),
      ...options.headers,
    },
    // Nếu POST/PUT/PATCH mà không có body thì tự thêm body rỗng
    ...(needsBody && !hasBody ? { body: '{}' } : {}),
    ...options,
  };

  let response = await fetch(url, defaultOptions);

  // Nếu gặp lỗi 401 (Hết hạn Access Session trên Redis)
  if (response.status === 401 && !path.includes('/auth/login') && !path.includes('/auth/refresh')) {
    // Tự động gọi API gia hạn từ Refresh Token
    const refreshRes = await fetch(`${API_BASE_URL}/auth/refresh`, {
      method: 'POST',
      credentials: 'include',
      headers: { 'Content-Type': 'application/json' },
      body: '{}',
    });

    if (refreshRes.ok) {
      // Refresh thành công, gọi lại yêu cầu ban đầu lần 2
      response = await fetch(url, defaultOptions);
    } else {
      // Refresh thất bại -> Chuyển về Login
      if (typeof window !== 'undefined') {
        window.location.href = '/login';
      }
    }
  }

  return response;
};
